export default __webpack_public_path__ + "assets/radio_wrong.355ca24a.svg";